import DOMPurify from "dompurify";
import "./InfoImageSection.css";
import { LEFT_ORIENTATION, RIGHT_ORIENTATION } from "../siteUtils";
import { forwardRef } from "react";

const InfoImageSection = forwardRef(
  ({ orientation, header, text, img }, ref) => {
    return (
      <section
        ref={ref}
        className={orientation === LEFT_ORIENTATION ? "left" : ""}
      >
        {orientation === RIGHT_ORIENTATION && (
          <>
            <div className="imageContainer imageContainer--decorative">{img}</div>
            <div className="textContainer">
              <span>
                <h2
                  style={{
                    color: "#755673",
                  }}
                >
                  {header}
                </h2>
                <p
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
                />
              </span>
            </div>
          </>
        )}
        {orientation === LEFT_ORIENTATION && (
          <>
            <div className="textContainer left">
              <span>
                <h2
                  style={{
                    color: "#755673",
                  }}
                >
                  {header}
                </h2>
                <p
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
                />
              </span>
            </div>
            <div className="imageContainer imageContainer--decorative">{img}</div>
          </>
        )}
      </section>
    );
  }
);

export default InfoImageSection;
